module.exports = __webpack_public_path__ + "img/Logo.549ab99e.png";